/* eslint-disable react/require-default-props */
import { RoutesProvider } from '@folklore/routes';
import { TrackingContainer } from '@folklore/tracking';
import PropTypes from 'prop-types';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Router } from 'wouter';

import { ModalsProvider } from '../contexts/ModalsContext';
import Routes from './Routes';

const propTypes = {
    intl: PropTypes.shape({
        locale: PropTypes.string,
        messages: PropTypes.oneOfType([
            PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
            PropTypes.objectOf(PropTypes.string),
        ]),
    }),
    routes: PropTypes.objectOf(PropTypes.string),
    // environment: PropTypes.string,
    apiUrl: PropTypes.string,
};

function App({
    intl = null,
    routes = {
        home: '/',
    },
    // environment = null,
    apiUrl = null,
}) {
    const { locale = 'fr', messages = {} } = intl || {};
    return (
        <IntlProvider locale={locale} messages={messages[locale] || messages}>
            <TrackingContainer>
                <Router>
                    <RoutesProvider routes={routes}>
                        <ModalsProvider>
                            <Routes apiUrl={apiUrl} />
                        </ModalsProvider>
                    </RoutesProvider>
                </Router>
            </TrackingContainer>
        </IntlProvider>
    );
}

App.propTypes = propTypes;

export default App;
